// extracted by mini-css-extract-plugin
export default {"copyButton":"bGFx6ZmC359zeJWto9yp","inputFieldWrapper":"LDFNeVrWdsiqal9bzzF1"};